import Button from 'components/Button';
import { Modal, ModalProps } from 'components/Modal';
import messages from './ImportCsvModal.messages';
import styles from './ImportCsvModal.module.css';

type Props = {
  onRequestClose: VoidFunction;
  onSubmit: () => void;
  isLoading: boolean;
} & ModalProps;

const ImportCsvModal = ({
  onRequestClose,
  onSubmit,
  isLoading,
  ...restOfProps
}: Props): JSX.Element | null => (
  <Modal
    {...restOfProps}
    onRequestClose={onRequestClose}
    className={styles.importCsvModal}
    disabled={isLoading}
  >
    <h3 className={styles.importCsvModal__title}>{messages.title}</h3>
    <p className={styles.importCsvModal__text}>{messages.text}</p>

    <div className={styles.importCsvModal__buttons}>
      <Button variant={'outline'} onClick={onRequestClose} disabled={isLoading}>
        {messages.buttonCancel}
      </Button>
      <Button
        isLoading={isLoading}
        onClick={onSubmit}
        className={styles.importCsvModal__submitButton}
      >
        {messages.buttonSubmit}
      </Button>
    </div>
  </Modal>
);

export default ImportCsvModal;
